var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticClass: "add-case-btn",
          attrs: { type: "success", icon: "el-icon-plus", size: "small" },
          on: { click: _vm.add }
        },
        [_vm._v("新增用户")]
      ),
      _c("SearchForm", { on: { submit: _vm.searchFormSubmit } }),
      _c("CustomTable", {
        attrs: {
          data: _vm.newTableData,
          header: _vm.tableHeader,
          settings: {
            isLoading: _vm.loading,
            currentPage: _vm.pageNum,
            pageSize: _vm.pageSize,
            total: _vm.total
          }
        },
        on: {
          pageSizeChange: _vm.handleSizeChange,
          currentPageChange: _vm.handleCurrentChange
        },
        scopedSlots: _vm._u([
          {
            key: "headerImage",
            fn: function(data) {
              return [
                _c("el-image", {
                  staticStyle: { width: "50px", height: "50px" },
                  attrs: { src: data.scope.row.headImg, fit: "cover" },
                  on: {
                    click: function($event) {
                      return _vm.show(data.scope.index)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "video",
            fn: function(data) {
              return [
                data.scope.row.url
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.player(data.scope.row.url)
                          }
                        }
                      },
                      [_vm._v("查看视频")]
                    )
                  : _c("span", [_vm._v("暂无")])
              ]
            }
          },
          {
            key: "action",
            fn: function(data) {
              return [
                _vm.jurisdiction.user.info
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.onDetalis("see", data.scope.row.userId)
                          }
                        }
                      },
                      [_vm._v("查看详情")]
                    )
                  : _vm._e(),
                _vm.jurisdiction.user.info
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onDetalis("edit", data.scope.row.userId)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    )
                  : _vm._e(),
                _vm.jurisdiction.user.info
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onSetSign(
                              data.scope.row.name,
                              data.scope.row.userId,
                              data.scope.row.notaryId,
                              data.scope.row.videoId,
                              data.scope.row.disabledBtn
                            )
                          }
                        }
                      },
                      [_vm._v("个性化设置")]
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _c(
        "viewer",
        {
          ref: "viewer",
          staticClass: "viewer",
          attrs: { images: _vm.headImg },
          on: { inited: _vm.inited }
        },
        _vm._l(_vm.headImg, function(item, index) {
          return _c("img", {
            key: item.key + index,
            staticClass: "image",
            attrs: { src: item.src }
          })
        }),
        0
      ),
      _c("NotaryDetails", {
        ref: "notaryDetails",
        attrs: { currUserId: _vm.currUserId },
        on: { updateList: _vm.getList }
      }),
      _c("DialogSelectSign", {
        ref: "dialogSelectSign",
        attrs: {
          name: _vm.propsName,
          userId: _vm.propsUserId,
          disabledBtn: _vm.disabledBtn,
          notaryId: _vm.notaryId,
          videoId: _vm.videoId
        },
        on: { success: _vm.getList }
      }),
      _c("VideoPlayer", { ref: "videoPlayer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }